import { render, staticRenderFns } from "./fireTruckList.vue?vue&type=template&id=1b2034a4&"
import script from "./fireTruckList.vue?vue&type=script&lang=js&"
export * from "./fireTruckList.vue?vue&type=script&lang=js&"
import style0 from "./fireTruckList.vue?vue&type=style&index=0&id=1b2034a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports